import { render, staticRenderFns } from "./LastQuestions.vue?vue&type=template&id=42e85e20&scoped=true&"
import script from "./LastQuestions.vue?vue&type=script&lang=js&"
export * from "./LastQuestions.vue?vue&type=script&lang=js&"
import style0 from "./LastQuestions.vue?vue&type=style&index=0&id=42e85e20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42e85e20",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VContainer,VDataTable,VOverlay,VProgressCircular,VRow,VSelect})
